module.exports = __webpack_public_path__ + "static/img/level.bb93bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/level.png
// module id = aODF
// module chunks = 29